import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {InputTextModule} from '../../../../core/component/input-text/input-text.module';
import {FormFieldModule} from '../../../../core/component/form-field/form-field.module';
import {FormArrayInputModule} from '../../../../../components/common/form-array/form-array-input/form-array-input.module';
import {SelectModule} from '../../../../../components/common/select/select.module';
import {DatePickerModule} from '../../../../../components/common/date-picker/date-picker.module';
import {AmountInputModule} from '../../../../../components/common/amount/amount-input/amount-input.module';
import {CheckboxInputModule} from '../../../../../components/common/checkbox/checkbox-input/checkbox-input.module';
import {
    AccountingAccountSelectFilterModule
} from '../../../../accounting/account/api/component/accounting-account-select-filter/accounting-account-select-filter.module';
import {
    PaymentTypeSelectFilterModule
} from '../../../../accounting/paymentType/payment-type-select-filter/payment-type-select-filter.module';
import {LoadingModule} from '../../../../../components/common/loading/loading.module';
import {SaleSavePaymentRequestsFormComponent} from './sale-save-payment-requests-form.component';
import {
    LovValueSelectFilterModule
} from "../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module";
import {
    RadioButtonGroupInputModule
} from "../../../../../components/common/radio-button-group/radio-button-group-input/radio-button-group-input.module";
import {MatRadioModule} from "@angular/material/radio";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FormFieldModule,
        FormArrayInputModule,
        SelectModule,
        DatePickerModule,
        AmountInputModule,
        CheckboxInputModule,
        AccountingAccountSelectFilterModule,
        PaymentTypeSelectFilterModule,
        CheckboxInputModule,
        LoadingModule,
        InputTextModule,
        LovValueSelectFilterModule,
        RadioButtonGroupInputModule,
        MatRadioModule,
    ],
    declarations: [SaleSavePaymentRequestsFormComponent],
    exports: [
        SaleSavePaymentRequestsFormComponent
    ]
})
export class SaleSavePaymentRequestsFormModule {
}
